import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { defaultPagingSchema } from '../../../helpers/schemas/defaultPagingSchema';
import { rootRoute } from '../../../router/routes/rootRoute';

export const accountSearchResultFormSchema = defaultPagingSchema.extend({
	searchValue: z.string().optional().nullable().catch(''),
});

export const accountSearchResultRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: '/account-search-result',
	validateSearch: accountSearchResultFormSchema,
	component: lazyRouteComponent(
		() => import('./AccountSearchResultPage'),
		'AccountSearchResultPage',
	),
});
